import { Button } from '@mui/material';
import React from 'react';
import { useDrawer } from './context/DrawerContext';

const SignUpButton = props => {
    const {openDrawer} = useDrawer();
  
  return <Button variant='contained' onClick={() => openDrawer('sign-up')}>Sign up</Button>
}

export default SignUpButton;